/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSms/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSms({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSms",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSms.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z283Cmx': alignSelf,'--mt-2-Z283Cmx': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z283Cmx': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z283Cmx': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z283Cmx': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z283Cmx': opacity,'--w-10-Z283Cmx': typeof width === 'number' ? `${width}px` : width,'--h-11-Z283Cmx': typeof height === 'number' ? `${height}px` : height,'--a-7-Z283Cmx': isAnimated ? animation : "none",'--sd-8-Z283Cmx': isAnimated ? strokeDashoffset : 0,'--sd-9-Z283Cmx': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSms.SvgPath"
  data-view-path={viewPath}
 d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
 style={{'--f-12-Z283Cmx': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}